export default date => {
   return new Date(date).toLocaleString("fr-FR", { year: 'numeric', month: 'numeric', day: 'numeric' });
}

export const FormatDateEtHeure = date => {
    let date2 = date + "Z";
    return new Date(date2).toLocaleString("fr-FR", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
};

export const FormatDateInput = date => {
    if (date) {
        let d = new Date(date);
        if (!isNaN(d)) {
            return FormatISO(d).split('T')[0];
        }
    }
    return "";
}

const FormatISO = date => new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();

// Seul le format ISO 8601 est parse de facon identique par tous les moteurs JS.
// Pour le reste (ex: le champ texte libre finMarchePermanente, "lun. 05/06"), V8 (Edge/Chrome)
// invente une date alors que SpiderMonkey (Firefox) renvoie Invalid Date : meme code, meme donnee,
// PDF different. On ne tente donc new Date() que sur de l'ISO, sinon on affiche la valeur telle quelle.
const ISO_DATE = /^\d{4}-\d{2}-\d{2}([T ]|$)/;

const ToDateOrNull = value => {
    if (value instanceof Date) return isNaN(value) ? null : value;
    if (typeof value === "number") {
        let d = new Date(value);
        return isNaN(d) ? null : d;
    }
    if (typeof value !== "string" || !ISO_DATE.test(value.trim())) return null;
    let d = new Date(value.trim());
    return isNaN(d) ? null : d;
}

export const FormatDateShort = date => {// SAM. 10/08
    if (date) {
        let d = ToDateOrNull(date);
        if (d) {
            return d.toLocaleDateString("fr-FR", { weekday: 'short', month: 'numeric', day: 'numeric' });
        }
    }
    return date;
}

export const FormatDateShortAndYear = date => {
    if (date) {
        let d = ToDateOrNull(date);
        if (d) {
            return d.toLocaleDateString("fr-FR", { weekday: 'short', month: 'numeric', day: 'numeric', year: 'numeric' });
        }
    }
    return date;
}
